import { Component, Input, OnDestroy } from '@angular/core';
import { ODataLTextModel, UiResponsiveService } from '@evorait/pace-core';
import { faChevronDown, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { distinctUntilChanged, Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'pace-preclarification',
    templateUrl: './preclarification.component.html',
    styleUrls: ['./preclarification.component.scss'],
    standalone: false,
})
export class PreclarificationComponent implements OnDestroy {
    @Input() public preclarificationLongtextTitle: string;
    @Input() public preclarificationLongtext: ODataLTextModel[];

    public faChevronRight = faChevronRight;
    public faChevronDown = faChevronDown;
    public isCollapsed = true;
    private isMobile = false;
    private destroyTrigger$ = new Subject<void>();

    public constructor(private readonly uiResponsiveService: UiResponsiveService) {
        this.uiResponsiveService.isMobile$
            .pipe(distinctUntilChanged(), takeUntil(this.destroyTrigger$))
            .subscribe((isMobile) => {
                this.isMobile = isMobile;
                this.isCollapsed = isMobile;
            });
    }

    public ngOnDestroy(): void {
        this.destroyTrigger$.next();
        this.destroyTrigger$.complete();
    }

    /**
     * Toggle the collapsed state of the preclarification text when the user is on a mobile device.
     * This does not do anything on non-mobile devices, as the collapsed state is not toggleable.
     */
    public toggle(): void {
        if (this.isMobile) {
            this.isCollapsed = !this.isCollapsed;
        }
    }
}
